import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit} from '@angular/core';
import {ConfirmActionDialogComponent} from '../common/confirm-action-dialog/confirm-action-dialog.component';
import {CreateNewDialogComponent} from './create-new-dialog/create-new-dialog.component';
import {MatDialog, MatSnackBar, MatTableDataSource} from '@angular/material';
import {PromoMaterialGroup} from '../models/PromoMaterialGroup';
import {PromoMaterial} from '../models/PromoMaterial';

@Component({
  styleUrls: ['./settings.component.scss'],
  templateUrl: './settings.component.html'
})
export class SettingsComponent implements OnInit {
  manufacturersLoading: boolean;
  distributionCentersLoading: boolean;
  plCentersLoading: boolean;
  private user: any;
  public promoMaterialGroupDataSource: MatTableDataSource<PromoMaterialGroup>;
  public promoMaterialDataSource: MatTableDataSource<PromoMaterial>;
  public promoDisplayColumns: string[] = ['name', 'actions'];
  public promoMaterialDisplayColumns: string[] = ['alternate_id', 'name', 'actions'];
  public initManufacturersDisplayColumns: any = [{columnName: 'vendor_id', columnValue: 'ID'}, {
    columnName: 'vendor_name',
    columnValue: 'Όνομα'
  },
    {columnName: 'manufacturer_id', columnValue: 'ID Κατασκευαστή'},
    {columnName: 'storage_location', columnValue: 'Αποθήκη'}, {columnName: 'plant', columnValue: 'Εργοστάσιο'}, {
      columnName: 'user_name',
      columnValue: 'Όνομα Υπαλλήλου'
    },
    {
      columnName: 'status',
      columnValue: 'Κατάταση'
    },
    {
      columnName: 'actions',
      columnValue: 'Ενέργειες'
    }];
  public manufacturersDisplayColumns: any = this.initManufacturersDisplayColumns.map(col => col.columnName);
  public manufacturersDataSource = new MatTableDataSource<any>();
  public distributionCentersDataSource: any;
  public plCentersDataSource: any;
  public centersConfig: any;
  public isLoadingMaterials: boolean;
  public newGroup: string;
  public groupName: string;
  public editGroupName: string;
  public isGroupEditable: boolean;
  public isMaterialEditable: boolean;
  private updateGroupItem: any;
  private selectedMaterial: any;
  private selectedMaterialIndex: number;
  public newMaterial: any;
  private selectedGroupId;


  constructor(private authService: AuthService,
              private commonService: CommonService,
              private matDialog: MatDialog,
              private matSnackBar: MatSnackBar) {
    this.newMaterial = {
      materialId: '',
      materialName: ''
    };
    this.isMaterialEditable = false;
    this.isLoadingMaterials = false;
    this.isGroupEditable = false;
  }

  public async ngOnInit(): Promise<any> {
    this.manufacturersLoading = true;
    this.distributionCentersLoading = true;
    this.plCentersLoading = true;
    await this.initCalls();
  }

  private async initCalls() {
    this.user = await this.authService.getUser();
    await this.getManufacturers();
    await this.getInstallations();
    await this.get3PLCenters();
    await this.getPromos();
  }

  async refreshManufacturers() {
    await this.getManufacturers();
  }

  async refreshInstallations() {
    this.getInstallations();
  }

  async refresh3PL() {
    this.get3PLCenters();
  }

  private async getInstallations() {
    try {
      this.distributionCentersLoading = true;
      this.distributionCentersDataSource = await this.commonService.getSimpleList(`sale_point/complete?category_id=2`);
      this.centersConfig = {
        type: 1,
        dataSource: this.distributionCentersDataSource
      };
    } catch (e) {
    } finally {
      this.distributionCentersLoading = false;
    }
  }

  private async get3PLCenters() {
    try {
      this.plCentersLoading = true;
      this.plCentersDataSource = await this.commonService.getSimpleList(`sale_point/complete?category_id=3`);
      this.centersConfig = {
        type: 2,
        dataSource: this.plCentersDataSource
      };
    } catch (e) {
    } finally {
      this.plCentersLoading = false;
    }
  }

  private async getManufacturers() {
    try {
      this.manufacturersLoading = true;
      const result: any = await this.commonService.getSimpleList('vendors');
      result.forEach(data => {
        data.status = data.is_active === 0 ? 'Ανενεργή' : 'Ενεργή';
      });
      this.manufacturersDataSource.data = result;
    } catch (e) {
    } finally {
      this.manufacturersLoading = false;
    }
  }

  createNewVendor(edit: boolean, vendorId?: string) {
    // @ts-ignore
    const vendor = vendorId ? this.manufacturersDataSource.data.filter(d => d.vendor_id === vendorId) : null;
    const dialogReference = this.matDialog.open(CreateNewDialogComponent, {
      panelClass: 'no-padding-dialog',
      data: {
        edit,
        type: 0,
        vendor: edit ? vendor[0] : null
      }
    });

    dialogReference.afterClosed().subscribe(async (data) => {
      if (data) {
        await this.getManufacturers();
      }
    });
  }

  createNewInstallation(edit: boolean, installationId?: any) {
    const installation = installationId ? this.distributionCentersDataSource.data.filter(d => d.id === installationId) : null;
    const dialogReference = this.matDialog.open(CreateNewDialogComponent, {
      panelClass: 'no-padding-dialog',
      data: {
        edit,
        type: 1,
        installation: edit ? installation[0] : null
      }
    });

    dialogReference.afterClosed().subscribe(async (data) => {
      if (data) {
        this.getInstallations();
      }
    });
  }

  createNew3PL(edit: boolean, plId?: any) {
    const plCompany = plId ? this.plCentersDataSource.data.filter(d => d.id === plId) : null;
    const dialogReference = this.matDialog.open(CreateNewDialogComponent, {
      panelClass: 'no-padding-dialog',
      data: {
        edit,
        type: 2,
        threePL: edit ? plCompany[0] : null
      }
    });

    dialogReference.afterClosed().subscribe(async (data) => {
      if (data) {
        this.get3PLCenters();
      }
    });
  }

  async delete3PL(object: any) {
    const plCompanies = object.dataSource.filter(d => d.id === object.id);
    const company = plCompanies[0];
    company.action = 'delete';
    try {
      await this.commonService.updateObject('sale_point', company);
    } catch (e) {
    }
  }

  async deleteInstallation(object: any) {
    const installations = object.dataSource.filter(d => d.id === object.id);
    const installation = installations[0];
    installation.action = 'delete';
    try {
      await this.commonService.updateObject('sale_point', installation);
    } catch (e) {
    }
  }

  async deleteVendor(object: any) {
    const vendors = object.dataSource.filter(d => d.vendor_id === object.id);
    const vendor = {
      id: vendors[0].vendor_id,
      name: vendors[0].vendor_name,
      manufacturer_id: vendors[0].manufacturer_id,
      storage_location: vendors[0].storage_location,
      plant: vendors[0].plant,
      user_id: null,
      action: 'delete'
    };

    try {
      await this.commonService.updateObject('vendors', vendor);
      // object.refresh();
    } catch (e) {
    }
  }

  async activateVendor(object: any) {
    const vendors = object.dataSource.filter(d => d.vendor_id === object.id);
    const vendor = {
      id: vendors[0].vendor_id,
      name: vendors[0].vendor_name,
      manufacturer_id: vendors[0].manufacturer_id,
      storage_location: vendors[0].storage_location,
      plant: vendors[0].plant,
      user_id: null,
      action: 'update'
    };
    try {
      await this.commonService.updateObject('vendors', vendor);
    } catch (e) {
    }
  }


  async confirmDeletion(type: number, id: any) {
    const item = type === 0 ? 'κατασκευάστρια' : type === 1 ? 'εγκατάσταση' : '3PL';
    const body = {
      id,
      refresh: this.refreshManufacturers,
      dataSource: type === 0 ? this.manufacturersDataSource.data :
        type === 1 ? this.distributionCentersDataSource : this.plCentersDataSource
    };
    const d = this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        confirmFunction: async () => {
          type === 0 ? await this.deleteVendor(body) : type === 1 ? await this.deleteInstallation(body) : await this.delete3PL(body);
        },
        message: `Είστε σίγουροι ότι θέλετε να απενεργοποιήσετε την ${item}?`,
        title: 'Απενεργοποίηση'
      }
    });

    d.afterClosed().subscribe(async (response) => {
      await this.refreshManufacturers();
    });
  }

  async needRefresh($event) {
    if ($event === 1) {
      this.refreshInstallations();
    }
    if ($event === 2) {
      this.refresh3PL();
    }
  }

  getTooltipText(element: any) {
    return element.is_active ? 'Ενεργοποιημένη' : 'Απενεργοποιημένη';
  }

  getIconColor(element: any) {
    return element.is_active ? '#4caf50' : '#dd0330';
  }

  async confirmActivation(type: number, id: any) {
    const item = type === 0 ? 'κατασκευάστρια' : type === 1 ? 'εγκατάσταση' : '3PL';
    const d = this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        confirmFunction: async () => {
          await this.activateVendor({
            id,
            refresh: this.refreshManufacturers,
            dataSource: type === 0 ? this.manufacturersDataSource.data :
              type === 1 ? this.distributionCentersDataSource : this.plCentersDataSource
          });
        },
        message: `Είστε σίγουροι ότι θέλετε να ενεργοποιήσετε την ${item}?`,
        title: 'Ενεργοποίηση'
      }
    });

    d.afterClosed().subscribe(async (response) => {
      await this.refreshManufacturers();
    });
  }

  //#region Διαφημηστικά Υλικά
  async getPromos(): Promise<any> {
    try {
      const data = await this.commonService.getSimpleList('promo_material_group') as PromoMaterialGroup[];
      this.promoMaterialGroupDataSource = new MatTableDataSource<PromoMaterialGroup>(data);
    } catch (e) {
    }
  }

  async selectRow(id: number) {
    try {
      this.isLoadingMaterials = true;
      const groups = JSON.parse(JSON.stringify(this.promoMaterialGroupDataSource.data));
      const group = groups.find(x => x.id === id);
      this.groupName = group.name;
      this.selectedGroupId = id;
      this.promoMaterialDataSource = new MatTableDataSource<PromoMaterial>();
      const data = await this.commonService.getListWithParameters('promo_material', `group_id=${id}`) as PromoMaterial[];
      this.promoMaterialDataSource = new MatTableDataSource<PromoMaterial>(data);

    } catch (e) {
    } finally {
      this.isLoadingMaterials = false;
    }
  }

  async deleteGroup(id: number, index: number) {
    try {
      await this.commonService.deleteRecord(`promo_material_group/${id}`);
      this.toastMessages('Η κατηγορία διαγράφηκε με επιτυχία');
      const data = JSON.parse(JSON.stringify(this.promoMaterialGroupDataSource.data));
      data.splice(index, 1);
      this.promoMaterialGroupDataSource.data = data;
    } catch (e) {
    }
  }

  async deleteMaterial(id: any, index: any) {
    this.isLoadingMaterials = true;
    try {
      await this.commonService.deleteRecord(`promo_material/${id}`);
      this.toastMessages(`Το υλικό διαγράφηκε με επιτυχία απο την κατηγορία ${this.groupName}`);
      const data = JSON.parse(JSON.stringify(this.promoMaterialDataSource.data));
      data.splice(index, 1);
      this.promoMaterialDataSource.data = data;
    } catch (e) {
    } finally {
      this.isLoadingMaterials = false;
    }
  }

  applyFilterGroup(value: any): void {
    this.promoMaterialGroupDataSource.filter = value.trim().toLocaleLowerCase();
  }

  applyFilterMaterial(value: any): void {
    this.promoMaterialDataSource.filter = value.trim().toLocaleLowerCase();
  }

  async addGroup() {
    if (this.newGroup) {
      try {
        const result = await this.commonService.insertItem('promo_material_group', {description: this.newGroup});
        this.toastMessages('Η κατηγορία δημιουργήθηκε με επιτυχία');
        const model = {
          id: result,
          name: this.newGroup
        };
        const data = JSON.parse(JSON.stringify(this.promoMaterialGroupDataSource.data));
        data.push(model);
        this.promoMaterialGroupDataSource.data = data;
        this.resetUpdateGroup();
        this.toastMessages(`Η κατηγορία ${this.newGroup} δημιουργήθηκε με επιτυχία`);
      } catch (e) {
        this.toastMessages(`Αποτυχία δημιουργίας. Λόγος: ${e.message}`);
      }
    } else {
      this.toastMessages('Το όνομα κατηγορίας δεν μπορεί να είναι κενό');
    }
  }

  async addMaterial() {
    const model = {
      alternate_id: this.newMaterial.materialId,
      description: this.newMaterial.materialName,
      group_id: this.selectedGroupId
    };

    if (model.alternate_id !== '' && model.description !== '') {
      try {
        const result = await this.commonService.insertItem('promo_material', model);

        this.toastMessages(`Το υλικό δημιουργήθηκε με επιτυχία στην κατηγορία ${this.groupName}`);

        const material = {
          id: result,
          name: model.description,
          group_id: model.group_id,
          group_name: this.groupName,
          alternate_id: model.alternate_id
        };
        const data = JSON.parse(JSON.stringify(this.promoMaterialDataSource.data));
        data.push(material);
        this.promoMaterialDataSource.data = data;
        this.resetUpdateMaterialGroup();
        this.toastMessages(`Η εισαγωγή υλικού ${model.description} ολοκληρώθηκε με επιτυχία`);
      } catch (e) {
        this.toastMessages(`Η εισαγωγή υλικού απέτυχε. Λόγος: ${e.message}`);
      }
    } else {
      this.toastMessages('Το όνομα η ο κωδικός υλικού δεν μπορεί να είναι κενό');
    }
  }

  editGroup(id: any, index: any): void {
    this.isGroupEditable = true;
    this.editGroupName = this.promoMaterialGroupDataSource.data[index].name;
    this.updateGroupItem = {
      id,
      index,
      name: this.promoMaterialGroupDataSource.data[index].name
    };
  }

  editMaterial(material: any, index: any): void {
    this.selectedMaterialIndex = index;
    this.selectedMaterial = material;
    this.newMaterial.materialId = material.alternate_id;
    this.newMaterial.materialName = material.name;
    this.isMaterialEditable = true;
  }

  async updateGroup() {
    const updateModel = {
      id: this.updateGroupItem.id,
      description: this.editGroupName
    };
    const model = {
      id: this.updateGroupItem.id,
      name: this.editGroupName
    };

    if (this.editGroupName) {
      try {
        await this.commonService.updateObject('promo_material_group', updateModel);
        this.toastMessages('Η ενημέρωση ολοκληρώθηκε με επιτυχία');
      } catch (e) {
        this.toastMessages(`Η ενημέρωση απέτυχε. Λόγος: ${e.message}`);
      }

      const index = this.updateGroupItem.index;
      const data = JSON.parse(JSON.stringify(this.promoMaterialGroupDataSource.data));
      data[index] = model;
      this.promoMaterialGroupDataSource.data = data;

      this.resetUpdateGroup();
    } else {
      this.toastMessages('Το όνομα κατηγορίας δεν μπορεί να είναι κενο');
    }
  }

  async updateMaterial() {

    const model = {
      id: this.selectedMaterial.id,
      alternate_id: this.newMaterial.materialId,
      description: this.newMaterial.materialName,
      group_id: this.selectedMaterial.group_id
    };

    const updatedMaterial = {
      id: this.selectedMaterial.id,
      alternate_id: this.newMaterial.materialId,
      name: this.newMaterial.materialName,
      group_id: this.selectedMaterial.group_id
    };


    if (model.alternate_id !== '' && model.description !== '') {
      this.isLoadingMaterials = true;
      try {
        await this.commonService.updateObject('promo_material', model);
        const data = JSON.parse(JSON.stringify(this.promoMaterialDataSource.data));
        data[this.selectedMaterialIndex] = updatedMaterial;
        this.promoMaterialDataSource.data = data;
        this.resetUpdateMaterialGroup();
      } catch (e) {
        if (e.error.error.errno === 1264) {
          this.toastMessages(`Η ενημέρωση υλικού απέτυχε. Λόγος: Λάθος κωδικός υλικού`);
        } else if (e.error.error.errno === 1451) {
          this.toastMessages(`Η ενημέρωση υλικού απέτυχε. Λόγος: Το υλικό βρίσκεται ήδη σε αίτηση`);
        } else {
          this.toastMessages(`Η ενημέρωση υλικού απέτυχε. Λόγος: ${e.message}`);
        }
      } finally {
        this.isLoadingMaterials = false;
      }
    } else {
      this.toastMessages('Το όνομα η ο κωδικός υλικού δεν μπορεί να είναι κενό');
    }
  }

  resetUpdateGroup(): void {
    this.newGroup = '';
    this.updateGroupItem = {};
    this.isGroupEditable = false;
    this.editGroupName = '';
  }

  resetUpdateMaterialGroup(): void {
    this.isMaterialEditable = false;
    this.newMaterial.materialName = '';
    this.newMaterial.materialId = '';
  }

  isNewMaterialValid(): boolean {
    return this.newMaterial.materialName === '' || this.newMaterial.materialId === '';
  }

  fieldsDisabled(): boolean {
    if (this.promoMaterialDataSource) {
      if (this.promoMaterialDataSource.data) {
        return false;
      }
    } else {
      return true;
    }
  }

  //#endregion

  toastMessages(message: string): void {
    this.matSnackBar.open(message, '', {
      duration: 5000,
    });
  }

  canShow() {
    return this.commonService.canShowSettingsSyntelesteTab(this.user);
  }

  canShowHQ() {
    return this.commonService.canShowΗQ(this.user);
  }

  canShowAutomations() {
    return this.commonService.canShowSettingsAutomationsTab(this.user);
  }

  canShowPlirotis() {
    return this.commonService.canShowPlirotis();
  }

  canShowPoints() {
    return this.commonService.canShowSettingsPointsTab(this.user);
  }

  canShowPromo() {
    return this.commonService.canShowSettingsPromoTab(this.user);
  }

  canShowSpareParts() {
    return this.commonService.canShowSettingsSparePartsTab(this.user);
  }

  canShowSalesGroup() {
    return this.commonService.canShowSalesGroup(this.user);
  }

}
